export class Statistics {
  constructor(http) {
    this.http = http;
  }

  fetchStats(startDate, endDate) {
    const params = {};

    if (startDate && endDate) {
      params.startDate = startDate.valueOf();
      params.endDate = endDate.valueOf();
    }

    return this.http.get('finances', { params }).then(response => response.data);
  }

  fetchEmptyStats() {
    return this.http.get(`finances/empty`).then(response => response.data);
  }

}


